import React from 'react';
import EditorialHero from '../components/EditorialHero';
import EditorialAbout from '../components/EditorialAbout';
import BGNLiveSection from '../components/BGNLiveSection';
import FeaturedEventSection from '../components/FeaturedEventSection';
import BGNSpotlightSection from '../components/BGNSpotlightSection';
import EditorialFooter from '../components/EditorialFooter';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <EditorialHero />
      <EditorialAbout />
      <BGNLiveSection />
      <FeaturedEventSection />
      <BGNSpotlightSection />
      <EditorialFooter />
    </div>
  );
};

export default HomePage;